
export default class Utilities {
  static toggle(element, value) {
    if(value === undefined) {
      value = 'block';
    }
    element.css('display', element.css('display') === 'none' ? value : 'none');
  }
}